var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTotalBookingRight = function SvgTotalBookingRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 51 71"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1CCFCE",
    d: "M40.84.31a37.32 37.32 0 1 0 37.31 37.31A37.36 37.36 0 0 0 40.84.31m0 67.27a30 30 0 1 1 0-60 30 30 0 0 1 0 60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFC95D",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M31.18 49.25 1.79 78.64"
  })));
};
export default SvgTotalBookingRight;